export default "__VITE_ASSET__BnQusmhx__"